<template>
  <section
    id="al-page"
    :dir="$functions.currentLangDirection()"
  >
    <!-- آمار کلی -->
    <div class="al-grid">
      <div class="al-card al-c1">
        <div class="al-val">{{ overview.totalAll || 0 }}</div>
        <div class="al-lbl">کل درخواست‌ها</div>
      </div>
      <div class="al-card al-c2">
        <div class="al-val">{{ overview.totalToday || 0 }}</div>
        <div class="al-lbl">امروز</div>
      </div>
      <div class="al-card al-c3">
        <div class="al-val">{{ overview.totalThisHour || 0 }}</div>
        <div class="al-lbl">این ساعت</div>
      </div>
      <div class="al-card al-c4">
        <div class="al-val">{{ overview.totalThisMonth || 0 }}</div>
        <div class="al-lbl">این ماه</div>
      </div>
      <div class="al-card al-c5">
        <div class="al-val">{{ overview.cachedCount || 0 }}</div>
        <div class="al-lbl">از کش</div>
      </div>
      <div class="al-card al-c6">
        <div class="al-val">{{ overview.freshCount || 0 }}</div>
        <div class="al-lbl">تازه (API)</div>
      </div>
    </div>

    <!-- جدول کاربران -->
    <b-card class="al-tbl-card">
      <h5 class="al-title">آمار به تفکیک کاربر</h5>
      <v-text-field
        v-model="search"
        label="جستجو (نام، موبایل)"
        class="al-search"
      />
      <v-data-table
        :headers="userHeaders"
        :items="users"
        :search="search"
        :items-per-page="20"
        :footer-props="footerProps"
        class="al-table"
        mobile-breakpoint="0"
        :loading="loading"
        loading-text="در حال بارگذاری..."
      >
        <template v-slot:item.fullName="{ item }">
          <span class="al-name">{{ item.userName }} {{ item.userFamily }}</span>
        </template>
        <template v-slot:item.avgResponseTime="{ item }">
          <span :class="item.avgResponseTime > 5000 ? 'al-slow' : 'al-ok'">
            {{ Math.round(item.avgResponseTime || 0) }} ms
          </span>
        </template>
        <template v-slot:item.lastRequest="{ item }">
          <span class="al-dt">{{ formatDate(item.lastRequest) }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <button
            class="al-btn"
            @click="showUserDetail(item)"
          >
            جزئیات
          </button>
        </template>
      </v-data-table>
    </b-card>

    <!-- مودال جزئیات کاربر -->
    <b-modal
      id="modal-user-detail"
      ref="modal-user-detail"
      centered
      size="xl"
      :title="'جزئیات درخواست‌های ' + detailUser.userName + ' ' + detailUser.userFamily"
      hide-footer
    >
      <div
        v-if="detailLoading"
        class="al-loading"
      >
        در حال بارگذاری...
      </div>
      <div v-else>
        <div class="al-info">
          <span><strong>موبایل:</strong> {{ detailUser.userMobile }}</span>
          <span><strong>تعداد دستگاه:</strong> {{ detailUser.deviceCount }}</span>
          <span><strong>کل درخواست‌ها:</strong> {{ detailUser.totalRequests }}</span>
        </div>
        <v-data-table
          :headers="detailHeaders"
          :items="detailLogs"
          :items-per-page="20"
          :footer-props="footerProps"
          class="al-table al-dtl"
          mobile-breakpoint="0"
          dense
        >
          <template v-slot:item.createdAt="{ item }">
            <span class="al-dt">{{ formatDateTime(item.createdAt) }}</span>
          </template>
          <template v-slot:item.cached="{ item }">
            <span :class="item.cached ? 'al-bg-g' : 'al-bg-o'">
              {{ item.cached ? 'کش' : 'تازه' }}
            </span>
          </template>
          <template v-slot:item.success="{ item }">
            <span :class="item.success ? 'al-bg-g' : 'al-bg-r'">
              {{ item.success ? 'موفق' : 'خطا' }}
            </span>
          </template>
          <template v-slot:item.responseTime="{ item }">
            {{ item.responseTime }} ms
          </template>
          <template v-slot:item.coords="{ item }">
            <span class="al-coord">{{ item.lat.toFixed(4) }}, {{ item.lng.toFixed(4) }}</span>
          </template>
        </v-data-table>
        <div
          v-if="detailTotalPages > 1"
          class="al-pager"
        >
          <button
            class="al-btn"
            :disabled="detailPage <= 1"
            @click="loadUserDetail(detailPage - 1)"
          >
            قبلی
          </button>
          <span class="al-pg-info">صفحه {{ detailPage }} از {{ detailTotalPages }}</span>
          <button
            class="al-btn"
            :disabled="detailPage >= detailTotalPages"
            @click="loadUserDetail(detailPage + 1)"
          >
            بعدی
          </button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import {
  BCard, BButton, BModal,
} from 'bootstrap-vue'
import addressLogService from '@/services/addressLog.service'

export default {
  components: {
    BCard,
    BButton,
    BModal,
  },
  data() {
    return {
      loading: true,
      search: '',
      overview: {},
      users: [],
      detailUser: {},
      detailLogs: [],
      detailLoading: false,
      detailPage: 1,
      detailTotalPages: 1,
      footerProps: {
        'items-per-page-options': [10, 20, 50, 100],
        'items-per-page-text': 'تعداد در صفحه:',
      },
    }
  },
  computed: {
    userHeaders() {
      return [
        { text: 'نام کاربر', value: 'fullName' },
        { text: 'موبایل', value: 'userMobile' },
        { text: 'کل درخواست', value: 'totalRequests' },
        { text: 'امروز', value: 'todayRequests' },
        { text: 'از کش', value: 'cachedRequests' },
        { text: 'ناموفق', value: 'failedRequests' },
        { text: 'تعداد دستگاه', value: 'deviceCount' },
        { text: 'میانگین پاسخ', value: 'avgResponseTime' },
        { text: 'آخرین درخواست', value: 'lastRequest' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
    detailHeaders() {
      return [
        { text: 'تاریخ', value: 'createdAt' },
        { text: 'IMEI', value: 'imei' },
        { text: 'عنوان دستگاه', value: 'deviceTitle' },
        { text: 'مختصات', value: 'coords' },
        { text: 'آدرس', value: 'formatted_address' },
        { text: 'منبع', value: 'source' },
        { text: 'کش', value: 'cached' },
        { text: 'وضعیت', value: 'success' },
        { text: 'زمان پاسخ', value: 'responseTime' },
      ]
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    async initialize() {
      this.loading = true
      try {
        const res = await addressLogService.getSummary()
        if (res.status === 'success' && res.result) {
          this.overview = res.result.overview || {}
          this.users = res.result.users || []
        }
      } catch (e) {
        console.error('Error loading address log summary:', e)
      }
      this.loading = false
    },
    async showUserDetail(user) {
      this.detailUser = user
      this.detailPage = 1
      this.$refs['modal-user-detail'].show()
      await this.loadUserDetail(1)
    },
    async loadUserDetail(page) {
      this.detailLoading = true
      try {
        const res = await addressLogService.getUserDetail(this.detailUser._id, page)
        if (res.status === 'success' && res.result) {
          this.detailLogs = res.result.logs || []
          this.detailPage = res.result.page
          this.detailTotalPages = res.result.totalPages
        }
      } catch (e) {
        console.error('Error loading user detail:', e)
      }
      this.detailLoading = false
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('fa-IR')
    },
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      return `${d.toLocaleDateString('fa-IR')} ${d.toLocaleTimeString('fa-IR')}`
    },
  },
}
</script>

<style>
/* استایل‌های v-data-table footer - باید global باشه */
#al-page .v-data-footer {
  direction: rtl;
  font-family: Vazir, sans-serif;
  font-size: 0.82rem;
  padding: 8px 12px;
  border-top: 1px solid #eee;
}
#al-page .v-data-footer__select {
  direction: rtl;
  margin-right: 0;
  margin-left: 16px;
}
#al-page .v-data-footer__select .v-select {
  margin: 0 8px;
}
#al-page .v-data-footer__pagination {
  direction: ltr;
  margin: 0 12px;
  font-size: 0.82rem;
}
#al-page .v-data-footer__icons-before,
#al-page .v-data-footer__icons-after {
  direction: ltr;
}
</style>

<style scoped>
#al-page {
  padding: 15px;
  font-family: Vazir, sans-serif;
}

/* گرید آمار */
.al-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}
@media (max-width: 992px) {
  .al-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 576px) {
  .al-grid { grid-template-columns: repeat(2, 1fr); }
}

.al-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px 12px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-top: 3px solid #ddd;
  transition: transform 0.2s;
}
.al-card:hover { transform: translateY(-2px); }
.al-c1 { border-top-color: #4361ee; }
.al-c2 { border-top-color: #2ec4b6; }
.al-c3 { border-top-color: #ff6b6b; }
.al-c4 { border-top-color: #fca311; }
.al-c5 { border-top-color: #7209b7; }
.al-c6 { border-top-color: #06d6a0; }

.al-val {
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
}
.al-lbl {
  font-size: 0.8rem;
  color: #888;
  margin-top: 4px;
}

/* کارت جدول */
.al-tbl-card {
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.al-title {
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #4361ee;
  display: inline-block;
}
.al-search {
  max-width: 350px;
}
.al-table {
  font-size: 0.85rem;
}
.al-dtl {
  font-size: 0.8rem;
}
.al-name {
  font-weight: 500;
  color: #333;
}

/* دکمه جزئیات */
.al-btn {
  background: #4361ee;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 5px 14px;
  font-size: 0.78rem;
  font-family: Vazir, sans-serif;
  cursor: pointer;
  transition: background 0.2s;
}
.al-btn:hover { background: #3451d1; }
.al-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* بج‌ها */
.al-bg-g {
  background: #e8f5e9;
  color: #2e7d32;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}
.al-bg-o {
  background: #fff3e0;
  color: #e65100;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
}
.al-bg-r {
  background: #ffebee;
  color: #c62828;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
}
.al-slow {
  color: #c62828;
  font-weight: 600;
}
.al-ok {
  color: #2e7d32;
}
.al-dt {
  direction: ltr;
  display: inline-block;
  font-size: 0.8rem;
  color: #666;
}
.al-coord {
  direction: ltr;
  display: inline-block;
  font-size: 0.78rem;
  font-family: monospace;
  color: #555;
}

/* مودال */
.al-info {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 15px;
  padding: 10px 15px;
  background: #f7f8fc;
  border-radius: 8px;
  font-size: 0.85rem;
}
.al-loading {
  text-align: center;
  padding: 40px;
  color: #888;
}
.al-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
  padding: 10px 0;
}
.al-pg-info {
  font-size: 0.85rem;
  color: #666;
}
</style>
